import React from 'react';
import { useParams, useLocation, useHistory } from 'react-router-dom';
import { DelegationCargoDetailPage } from '@ontruck/fe-core';

export function DelegationCargoDetailModule({ config }) {
  let { id } = useParams();
  let location = useLocation();
  const history = useHistory();

  const handleGoToDelegation = () => {
    history.push('/delegation');
  };

  return (
    <DelegationCargoDetailPage
      config={config}
      cargoId={id}
      pathname={location.pathname}
      onCloseDetail={handleGoToDelegation}
      onGoingBack={handleGoToDelegation}
    />
  );
}
